// This class has been introduce to prevent a nasty circular refrence during dependency injection.
export class SysApiDeviceAuthenticationKeyringService {
	private keyring: string | undefined = undefined;

	public set(keyring: string): void {
		this.keyring = keyring;
	}

	public get(): string | undefined {
		return this.keyring;
	}

	public getForMutation(): string {
		return this.keyring || '';
	}
}
